import React, { useContext, useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faXmark,
  faChevronUp,
} from "@fortawesome/free-solid-svg-icons";
import EventContext from "./EventContext";
import "./CreateEvent.css";
import GooglePlacesAutocomplete from "react-google-autocomplete";
import axios from "axios";
import UserContext from "../../../../UserContext";
import { ToastContainer, toast } from "react-toastify";
import Events from "./Events";
import { StandaloneSearchBox, LoadScript, useJsApiLoader} from '@react-google-maps/api';

const CreateEvent = () => {
  const {userInfo} = useContext(UserContext);
  const { handleCreateEvent, createEvent,setEvents} = useContext(EventContext);
  const [minutes, setMinutes] = useState(0);
  const [hours, setHours] = useState(0);
  const [address, setAddress] = useState("");
  const [city, setCity] = useState('');
  const [pincode, setPincode] = useState();
  const [country, setCountry] = useState('');
  const [title,setEventName] = useState();
  const [description,setEventDescription] = useState();
  const [date,setDate] = useState();
  const [time,setTime] = useState();
  const [ticketPrice,setPrice] = useState();
  const [numberOfTickets,setTotalTickets] = useState();
  const [duration,setDuration] = useState();
  const [email,setEmail] = useState(userInfo.email)
  // const [autocomplete, setAutocomplete] = useState(null);
  // const [autocompleteValue, setAutocompleteValue] = useState('');
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [ libraries,setLibraries ] = useState(['places']);

  const [tag, setSelectedOption] = useState('Music');

  const inputRef = useRef();

  // const handlePlaceChange = () => {
  //   const [place] = inputRef.current.getPlaces();
  //   if(place) {
  //     console.log(place.formatted_address);
  //     console.log(place.geometry.location.lat());
  //     console.log(place.geometry.location.lng());
  //   }
  // }


  const handlePlaceChange = () => {
    const [place] = inputRef.current.getPlaces();
    if (place) {
      const addressComponents = place.address_components || [];
  
      let address = '';
      let city = '';
      let postcode = '';
      let country = '';

      console.log(addressComponents)
  
      for (const component of addressComponents) {
        const types = component.types || [];

        if (types.includes('street_number')) {
          address += component.long_name + ' ';
        }
  
        if (types.includes('street_address') || types.includes('premise') || types.includes('route')) {
          address += component.long_name;
        }
  
        if (types.includes('locality') || types.includes('postal_town')) {
          city = component.long_name;
          setCity(city)
        }
  
        if (types.includes('postal_code')) {
          postcode = component.long_name;
          setPincode(postcode)
        }
  
        if (types.includes('country')) {
          country = component.long_name;
          setCountry(country)
        }
      }
      
      setAddress(address)
      setLatitude(place.geometry.location.lat())
      setLongitude(place.geometry.location.lng())

      console.log('Address:', address);
      console.log('City:', city);
      console.log('Postcode:', postcode);
      console.log('Country:', country);
    }
  };
  


  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: 'AIzaSyC87PT659RDn0iG3G4G-lDOHQK7wUw6txc',
    libraries: libraries,
  });


  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
  };




  const handleCross = () => {
    handleCreateEvent();
  };

  const handleIncreaseDuration = () => {

    if (minutes < 50) {
      setMinutes((prev) => prev + 10);
    } else {
      setMinutes(0);
      setHours((prev) => prev + 1);
    }
  
    var total = (hours * 60) + minutes + 10; 
  
    setDuration(total);
    
  };

  const handleDecreaseDuration = () => {

    if (minutes > 0) {
      setMinutes((prev) => prev - 10);
    } else if (hours > 0) {
      setHours((prev) => prev - 1);
      setMinutes(50);
    }
  
    var total = (hours * 60) + minutes - 10; 
  
    setDuration(total);

  };

  // useEffect(()=> {
  //   console.log("Change state = ", createEvent);
  // },[handleCreateEvent]);


  const handleCreateEventButton = async () => {
    console.log(duration);
    try {
      const body = {
        title,
        email,
        description,
        tag,
        date,
        time,
        ticketPrice,
        numberOfTickets,
        location: {
          address,
          city,
          country,
          pincode,
          latitude,
          longitude,
        },
        duration
      };
      const response = await axios.post('https://event-finder12.onrender.com/events/createevent', body);
      toast.success("Event has been created.");
      setEvents(prevEvents => [...prevEvents, response.data]);
      handleCreateEvent(); 
    } catch (err) {
      console.log("An error occurred", err.message);
      if (err.response && err.response.data && err.response.data.message) {
        toast.error(err.response.data.message);
      } else {
        toast.error("An error occurred while creating the event.");
      }
    }
  };

  

  return (
    <div>
        {createEvent ? (<>
            <div className="create-event-outer-container">
      <div className="create-event-container">
        <ToastContainer/>
        <div className="create-event-header">
          <h3>Create Event</h3>
          <div onClick={handleCross} className="cross-mark">
            <FontAwesomeIcon icon={faXmark} />
          </div>
        </div>
        <div className="create-event-title">
          <h4>Event name & description</h4>
          <div className="create-event-forms">
            <input onChange={(e) => setEventName(e.target.value)} type="text" placeholder="Enter event name" />
            <div className="description">
              <textarea
                onChange={(e) => setEventDescription(e.target.value)}
                placeholder="Enter event description"
                className="description-textarea"
              />
            </div>
          </div>
        </div>
        <div className="create-event-timings">
          <div className="create-event-input">
            <h4>Date</h4>
            <input onChange={(e) => setDate(e.target.value)} type="date" />
          </div>
          <div className="create-event-input">
            <h4>Time</h4>
            <input onChange={(e) => setTime(e.target.value)} type="time" />
          </div>
          <div>
            <h4>Duration</h4>
            <div className="create-event-duration-input">
              <h4>
                {hours}h:{minutes}m
              </h4>
              <div className="duration-arrows">
                <FontAwesomeIcon
                  onClick={handleIncreaseDuration}
                  className="duration-arrow"
                  icon={faChevronUp}
                />
                <FontAwesomeIcon
                  onClick={handleDecreaseDuration}
                  className="duration-arrow"
                  icon={faChevronDown}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="create-event-location-container-row">
        <div className="create-event-location-container">
          <h4>Address</h4>
            {isLoaded && <StandaloneSearchBox onLoad={ref => (inputRef.current = ref)}
            onPlacesChanged={handlePlaceChange} >
                <input value={address} onChange={(e) => setAddress(e.target.value)} className="autocomplete-input" type="text" placeholder="Enter Address" />
            </StandaloneSearchBox>}
           

          
        </div>
        <div  className="create-event-location-container">
          <h4>City</h4>
          <input
            type="text"
            value={city}
            onChange={(e) => setCity(e.target.value)}
            placeholder="Enter city"
          />

        </div>
        </div>

        <div className="create-event-location-container-row">
        <div className="create-event-location-container">
          <h4>Post Code</h4>
          <input
            type="text"
            value={pincode}
            onChange={(e) => setPincode(e.target.value)}
            placeholder="Enter postcode"
          />
          
        </div>
        <div className="create-event-location-container">
          <h4>Country</h4>
          <input
            type="text"
            value={country}
            onChange={(e) => setCountry(e.target.value)}
            placeholder="Enter Country"
          /> 
        </div>
        </div>

        <div className="create-event-price-container">
          <div className="ticket-details-div-container">
            <div className="ticket-details-create-container ">
              <h4>Price per ticket</h4>
              <input min={0} onChange={(e) => setPrice(e.target.value)} type="number" />
              
            </div>
            <div className="ticket-details-create-container">
              <h4>Total Tickets</h4>
              <input min={10} onChange={(e) => setTotalTickets(e.target.value)} type="number" />
            </div>
          </div>
        </div>

        <div>
          <h4 className="create-event-tag">Tag</h4>
          <select
            id="selectOption"
            className="event-button create-event-tag-select"
            value={tag}
            onChange={handleSelectChange}
          >
            <option value="Music">Music</option>
            <option value="Sports">Sports</option>
            <option value="Job Event">Job Event</option>
            <option value="Charity Event">Charity Event</option>
            <option value="Religious Event">Religious Event</option>
          </select>
        </div>
        <div className="create-button-container">
            <div onClick={handleCreateEventButton} className="create-event-button">Create</div>
        </div>
      </div>
    </div>
        </>) : <Events/>}
    </div>
   
  );
};

export default CreateEvent;
